module.exports = __webpack_public_path__ + "static/media/non_member_sample_basket_03.de9907d4.jpg";